import { List, Map, fromJS } from 'immutable';
import { finish as updateCustomer } from './update';

export function request(state, { id }) {
    id = parseInt(id, 10);

    let playBreak = state.get('play-break') || Map();
    let user = playBreak.get(id) || Map();

    user = user
        .set('state', 'IN_PROGRESS')
        .set('errors', void 0);

    return state.set(
        'play-break', playBreak.set(id, user)
    );
}

export function error(state, { id, errors }) {
    id = parseInt(id, 10);

    let playBreak = state.get('play-break') || Map();
    let user = playBreak.get(id) || Map();

    user = user
        .set('state', 'ERROR')
        .set('errors', fromJS(errors));

    return state.set(
        'play-break', playBreak.set(id, user)
    );
}

export function finish(state, { id, customer }) {
    id = parseInt(id, 10);

    let playBreakEl = state.get('play-break') || Map();
    let userEl = playBreakEl.get(id) || Map();

    userEl = userEl
            .set('state', 'FINISHED')
            .set('errors', void 0);

    state = state.set('play-break', playBreakEl.set(id, userEl));

    return customer ? updateCustomer(state, { id, customer }) : state;
}

export function clear(state) {
    return state.set('play-break', Map());
}
